import React, { useState } from 'react';
import Layout from './components/Layout';
import ProfileCard from './components/ProfileCard';
import LandingPage from './components/LandingPage';
import SEO from './components/SEO';

const App: React.FC = () => {
  const [showContent, setShowContent] = useState(false);

  const handleEnter = () => {
    setShowContent(true);
  };

  return (
      <>
        <SEO />
        <Layout>
          {!showContent ? (
              <LandingPage onEnter={handleEnter} />
          ) : (
              <ProfileCard autoPlayMusic={true} />
          )}
        </Layout>
      </>
  );
};

export default App;